var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHazeX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C15.866 5 19 8.13401 19 12C19 12.3396 18.9745 12.6733 18.9277 13H16.8994C16.965 12.6769 17 12.3425 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 12.3425 7.03498 12.6769 7.10059 13H5.07227C5.02553 12.6733 5 12.3396 5 12C5 8.13401 8.13401 5 12 5Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17L19.1025 17.0049C19.6067 17.0562 20 17.4823 20 18C20 18.5177 19.6067 18.9438 19.1025 18.9951L19 19H1C0.447715 19 0 18.5523 0 18C0 17.4477 0.447715 17 1 17H19Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20L23.1025 20.0049C23.6067 20.0562 24 20.4823 24 21C24 21.5177 23.6067 21.9438 23.1025 21.9951L23 22H5C4.44772 22 4 21.5523 4 21C4 20.4477 4.44772 20 5 20H23Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14L23.1025 14.0049C23.6067 14.0562 24 14.4823 24 15C24 15.5177 23.6067 15.9438 23.1025 15.9951L23 16H5C4.44772 16 4 15.5523 4 15C4 14.4477 4.44772 14 5 14H23Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazeX2);
export default __webpack_public_path__ + "static/media/HazeX2.6e94e2f7a3646d8c6f64d4a97dc2784e.svg";
export { ForwardRef as ReactComponent };